export default {"src":"https://assets.ctr1.net/d1a32bdc1f09/_next/static/media/okta.9bd8c60e.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};